var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-overview',{attrs:{"controller":"Request","visible":_vm.visible},scopedSlots:_vm._u([{key:`read-requestStatus`,fn:function(item){return [_c('v-chip',{attrs:{"color":_vm.RequestStatusColor(item),"small":""}},[_vm._v(" "+_vm._s(item.requestStatus.value)+" ")])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }